'use strict';

angular.module('ClinicApp').directive('profileHours', function(OCHoursUtil) {
  return {
    scope: {
      editableHours: '=profileHours',
      editMode: '=', // enabled:true or disabled:false edit mode
      onSave: '&',
      onCancel: '&',
      hoursType: '=',
    },
    templateUrl: '/views/directives/_profile-hours.html',
    link: function($scope) {
      $scope.hours = _.cloneDeep($scope.editableHours);

      $scope.hasInvalidDay = function() {
        return OCHoursUtil.hasInvalidDay($scope.hours);
      };

      $scope.save = function() {
        return $scope.onSave({
          hours: $scope.hours,
        }).then(function() {
          $scope.editableHours = $scope.hours;
        });
      };

      $scope.cancel = function() {
        $scope.hours = _.cloneDeep($scope.editableHours);
        return $scope.onCancel();
      };

    },
  };
});
